module.exports = function() {
  return new Worker(__webpack_public_path__ + "f11e6ffbf0ccfe522dcc.worker.js");
};